import _styled from "@emotion/styled/base";
import { css } from '@emotion/react';
import { colors, rgba, getResetByTag, utilityStyles } from './../../styles';
var defaultStyles = function defaultStyles() {
  return /*#__PURE__*/css("background:", rgba(colors.coolGray_900, 0.55), ";bottom:0;left:0;position:fixed;right:0;top:0;z-index:1000;" + (process.env.NODE_ENV === "production" ? "" : ";label:defaultStyles;"));
};
var isLoadingStyles = function isLoadingStyles(_ref) {
  var isLoading = _ref.isLoading;
  if (isLoading === true) {
    return /*#__PURE__*/css("position:fixed;align-items:center;background:", rgba(colors.navy_500, 0.9), ";display:flex;justify-content:center;position:fixed;&[hidden]{display:none;}" + (process.env.NODE_ENV === "production" ? "" : ";label:isLoadingStyles;"));
  }
};
var isTypeStyles = function isTypeStyles(_ref2) {
  var type = _ref2.type;
  if (type === 'light') {
    return /*#__PURE__*/css("background:", rgba(colors.white, 0.9), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:isTypeStyles;"));
  }
};
var resetStyles = getResetByTag('div');
var StyledOverlay = /*#__PURE__*/_styled('div', process.env.NODE_ENV === "production" ? {
  target: "es95ov30"
} : {
  target: "es95ov30",
  label: "StyledOverlay"
})(resetStyles, defaultStyles, isLoadingStyles, isTypeStyles, utilityStyles);
export default StyledOverlay;